import service, {
  IComponent,
  IComponentId,
} from '@/services/component';
import { IPage } from '@/services/gql/generic-find';
import { debounceSearch, promiseError } from '@/store/utils';
import { IStateComponents } from './types';

export default () => ({
  namespaced: true,
  state: () => ({
    list: [],
    loadSeeds: [],
    page: {
      number: 1,
      query: {},
      recordCount: 0,
      size: 10,
    },
  } as IStateComponents),
  getters: {
    isSearchLoading: (state: IStateComponents) => !!state.loadSeeds.length,
  },
  mutations: {
    LOAD(state: IStateComponents, data: IComponent[] = []) {
      state.list = data;
    },
    LOAD_SEED_ADD(state: IStateComponents, seed: number) {
      state.loadSeeds = state.loadSeeds.concat(seed);
    },
    LOAD_SEED_CLEAR(state: IStateComponents) {
      state.loadSeeds = [];
    },
    LOAD_SEED_REMOVE(state: IStateComponents, seed: number) {
      state.loadSeeds = state.loadSeeds.filter(loadSeed => loadSeed !== seed);
    },
    REMOVE(state: IStateComponents, id: IComponentId) {
      // reduce record count by 1
      state.page.recordCount = state.page.recordCount - 1;

      // remove item from list
      state.list = state.list.filter((item: IComponent) => (
        item.id !== id
      ));
    },
    UPDATE_PAGE(state: IStateComponents, payload: any) {
      state.page = {
        ...state.page,
        ...payload,
      };
    },
  },
  actions: {
    load: ({ commit, state }: any, page: IPage) => (
      debounceSearch({
        commit,
        page,
        service,
        state,
        onSearch: (pageParams: any) => (
          service.find(`id, name`, {
            ...pageParams,
            where: state.page.query,
          })
        ),
      })
    ),
    remove: ({ commit }: any, id: string) => (
      service
        .remove(id)
        .then(() => commit('REMOVE', id))
        .catch(promiseError('COMPONENTS_REMOVE', commit))
    ),
  },
});
